import { CursorPaginatedResponse, PaginatedResponse } from '../../types'
import { pathUtils } from './pathnameFormatter'
interface FetchFullyCursorPaginatedDataProps<T> {
    fetchData: (args: any) => Promise<CursorPaginatedResponse<T> | undefined>
    onError?: () => void
}

export const fetchFullyCursorPaginatedData = async <T>({
    fetchData,
    onError,
    ...args
}: FetchFullyCursorPaginatedDataProps<T>): Promise<T[]> => {
    let allData = [] as T[]

    let response = await fetchData(args)
    if (!response) {
        return []
    }

    try {
        if (response.results) {
            allData = allData.concat(response.results)
        }

        while (response?.next) {
            const nextPath = new URL(response.next) as URL
            response = await fetchData({
                ...args,
                cursor: pathUtils.addQueryString(nextPath.pathname.replace('/', ''), nextPath.search),
            })

            if (!response) {
                onError?.()
                throw new Error('Error fetching paginated data')
            }

            if (response.results) {
                allData = allData.concat(response.results)
            }
        }
    } catch (error) {
        onError?.()
        throw new Error('Error fetching paginated data')
    }

    return allData
}

interface FetchFullyPagePaginatedDataProps<T> {
    fetchData: (args: any) => Promise<PaginatedResponse<T> | undefined>
    onError?: () => void
}

export const fetchFullyPagePaginatedData = async <T>({
    fetchData,
    onError,
    ...args
}: FetchFullyPagePaginatedDataProps<T>): Promise<T[]> => {
    let allData = [] as T[]
    let currentPage = 1

    try {
        while (true) {
            const response = await fetchData({ ...args, page: currentPage })

            if (!response) {
                break
            }

            if (response.entries) {
                allData = allData.concat(response.entries)
            }

            if (!response.nextPage) {
                break
            }

            if (typeof response.nextPage === 'string') {
                const url = new URL(response.nextPage)
                const pageParam = url.searchParams.get('page')
                currentPage = pageParam ? parseInt(pageParam, 10) : currentPage + 1
            } else {
                currentPage = response.nextPage
            }
        }
    } catch (error) {
        onError?.()
        throw new Error('Error fetching paginated data')
    }

    return allData
}
